export const CONSTANTS = {
  ROUTES: {
    showMessage: "message",
    login: "/login",
    auth2fa: "/2fa",
    home: "/",
    addPatients: "/patients/add",
    archive: "/archive",
    guides: "/guides",
    doctors: "/doctors",
    enterExitPatients: "/ptients/enter-exit",
    patientDetails: "/patients/details",
    addMedication: "/medication/add",
    pillsManager: "/pill/manager",
    adminPannel: "/admin-pannel",
    notAllowed: "/not-allowed",
  } as const,
  TIME_DAY: ["morning", "noon", "evening", "night"],
};

export type RoutesType =
  (typeof CONSTANTS.ROUTES)[keyof typeof CONSTANTS.ROUTES];
